import { createRouter } from "@nanostores/router";

export const AUTH_CALLBACK_PATH = "/auth-callback";

export const routes = {
  agentInvoke: "/agents/:sourceId/invoke",
  alertDetails: "/alerts/:id",
  alerts: "/alerts",
  alertSources: "/alert-sources",
  alertSourcesCreate: "/alert-sources/new",
  alertSourcesEdit: "/alert-sources/edit/:sourceId",
  authCallback: AUTH_CALLBACK_PATH,
  chat: "/chat",
  dashboard: "/dashboard",
  destinations: "/destinations",
  destinationsCreate: "/destinations/new",
  destinationsEdit: "/destinations/edit/:destinationId",
  entities: "/entities",
  entityClassCreate: "/entity-classes/new",
  entityClassEdit: "/entity-classes/:classId",
  entityCreate: "/entity-classes/:classId/entities/new",
  entityEdit: "/entity-classes/:classId/entities/:entityId",
  graph: "/graphs/:id",
  index: "/",
  integrations: "/integrations",
  integrationsCreate: "/integrations/new",
  integrationsEdit: "/integrations/edit/:integrationId",
  knowledgeBase: "/knowledge-base",
  knowledgeBaseDetail: "/knowledge-base/:id",
  newDestinations: "/destinations/new/:type",
  newIntegrations: "/integrations/new/:type",
  queryActionDelete:
    "/integrations/:integrationId/query-action/delete/:queryActionId",
  queryActionEdit:
    "/integrations/:integrationId/query-action/edit/:queryActionId",
  queryActionNew: "/integrations/:integrationId/query-action/new",
  settings: "/settings",
  signIn: "/sign-in",
} as const;

export const $router = createRouter(routes);
